//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/SelectFaceList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[0,"AtTimestamp",1,0],[1,"Bodies",0,"SelectBodyList",0],[1,"BoundaryFaces",0,"SelectFaceList",0],[0,"CreateRegionsOption",1,0],[0,"CutDirection",1,"Direction",0],[0,"Direction",1,"Direction",0],[1,"ExcludedFaces",0,"SelectFaceList",0],[1,"Faces",0,"SelectFaceList",0],[0,"FeatureType",1,0],[0,"IsoclineAngle",1,0],[0,"LimitSteepByCutDirection",1,0],[0,"SeedFace",1,"Face",0],[0,"SteepBody",1,"Body",0],[0,"SurfaceRegionName",1,0],[0,"TraverseInteriorEdges",1,0],[0,"UseTangentEdgeAngles",1,0]],[],[]];
SPLM.CAM.SurfaceRegions = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.SurfaceRegions";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.SurfaceRegions.FeatureTypes = Object.freeze({
    "Face" : "Face", "RegionOfFaces" : "RegionOfFaces", "Body" : "Body", "Steep" : "Steep"});

SPLM.CAM.SurfaceRegions.CreateRegionsTypes = Object.freeze({
    "Steep" : "Steep", "NonSteep" : "NonSteep", "SteepAndNonSteep" : "SteepAndNonSteep"});

export default SPLM;